import Vue from 'vue';
import VueRouter from 'vue-router';
import storage from '@checkout/services/storage';
import CheckoutStep1 from '@checkout/components/CheckoutStep1/CheckoutStep1.vue';
import CheckoutStep2 from '@checkout/components/CheckoutStep2/CheckoutStep2.vue';
import CheckoutStep3 from '@checkout/components/CheckoutStep3/CheckoutStep3.vue';
import CheckoutStep4 from '@checkout/components/CheckoutStep4/CheckoutStep4.vue';
import CheckoutStep5 from "@checkout/components/CheckoutStep5/CheckoutStep5.vue";
import CheckoutStep6 from "@checkout/components/CheckoutStep6/CheckoutStep6.vue";
import CheckoutStep7p from '@checkout/components/CheckoutStep7p/CheckoutStep7p.vue';
import ThankYou from "@checkout/components/CheckoutStep7/ThankYou.vue";

Vue.use(VueRouter);

const root_element = document.getElementById('payment-process_container');

if (root_element === null) {
    const root_element2 = document.getElementById('small-checkout');
    storage.save('locale', root_element2.getAttribute('data-locale'), true);
} else {
    storage.save('locale', root_element.getAttribute('data-locale'), true);
}


const routes = [
    {
        path: '/checkout/1',
        component: CheckoutStep1,
        name: 'checkout-step-1',
        meta: { stepNumber: '1' },
    },
    {
        path: '/checkout/2',
        beforeEnter(to, from, next) {
            localStorage.setItem('page-step', '2');
    
            next('/checkout/3');
        }        
        // component: CheckoutStep2,
        // name: 'checkout-step-2',
        // meta: { stepNumber: '2' },
    },
    {
        path: '/checkout/3',
        component: CheckoutStep3,
        name: 'checkout-step-3',
        meta: { stepNumber: '3' },
    },
    {
        path: '/checkout/4',
        component: CheckoutStep4,
        name: 'checkout-step-4',
        meta: { stepNumber: '4' },
    },
    {
        path: '/checkout/4a',
        component: CheckoutStep4,
        name: 'checkout-step-4a',
        meta: { stepNumber: '4a' },
    },
    {
        path: '/checkout/5',
        component: CheckoutStep5,
        name: 'checkout-step-5',
        meta: { stepNumber: '5' },
    },
    {
        path: '/checkout/6',
        component: CheckoutStep6,
        name: 'checkout-step-6',
        meta: { stepNumber: '6' },
    },
    {
        path: '/checkout/7',
        component: ThankYou,
        name: 'checkout-step-7',
        meta: { stepNumber: '7' },
    },
    {
        path: '/checkout/7p',
        component: CheckoutStep7p,
        name: 'checkout-step-7p',
        meta: { stepNumber: '7p' },
    },    
];


const router = new VueRouter({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    base: process.env.BASE_URL,
    linkExactActiveClass: 'active-link',
    mode: 'history',
    routes,
});

export default router;
